import { GeoLocationType } from '@/types/models/'
import { isNonEmptyArray, isNonEmptyString } from '@/utils/checks'
type AddressComponent = {
  long_name: string
  short_name: string
}

export const shouldUseInLocationFromSearchbar = ({
  address_components,
  types
}: {
  address_components: AddressComponent[]
  types: GeoLocationType[]
}) =>
  types.includes(GeoLocationType.administrative_area_level_1) &&
  address_components?.some(({ long_name }) => long_name === 'United States')
